import { ES } from "country-flag-icons/react/3x2";
import { SPANISH } from "./Spanish";
import { APP_STORAGE } from "../../_RuntimeConfig/_Config/Acomodar/AppConfig.Storage.js";
import { STORAGE_SESSION_HELPER } from "../../../_Helpers/Helpers/storageSession.helper.js";
import { onSetAlertTexts } from "../../../App/WEB/_Templates/_UI/Confirm/_Templates/_swalHelper";
import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

const LanguageContext = createContext();
const DEFAULT_LANG = "es";

export const useLanguage = () => {
    const context = useContext(LanguageContext);

    if (context === undefined) {
        return {
            useDataLanguage: {
                isLoading: false, currentLang: DEFAULT_LANG,
                translations: {}, availableLangs: [DEFAULT_LANG],
                availableLangsMeta: [],
            },
            call_translate: (key) => key,
            call_toggleTranslate: async () => { },
            call_refreshTranslate: async () => ({})
        };
    }

    return context;
};

const LANG_META = {
    es: { code: "es", Flag: ES, label: "Español" },
};
const SUPPORTED_LANGS = ["es"];
const STATIC_TRANSLATIONS = { es: SPANISH };

export const LanguageProvider = ({ children }) => {

    const [useNameDataLanguageState, setNameDataLanguageState] = useState({
        isLoading: true, currentLang: DEFAULT_LANG,
        translations: STATIC_TRANSLATIONS[DEFAULT_LANG],
        availableLangs: SUPPORTED_LANGS, availableLangsMeta: Object.values(LANG_META),
    });

    const resolveKey = (obj, path) => {
        return path.split(".").reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : null), obj);
    };

    const cb__translateCallback = useCallback((key, vars = {}) => {
        const value = resolveKey(useNameDataLanguageState.translations, key);
        if (value === null || typeof value !== "string") return key;

        return value.replace(/\{\{(\w+)\}\}/g, (_, varName) => {
            return vars[varName] !== undefined ? vars[varName] : `{{${varName}}}`;
        });
    }, [useNameDataLanguageState.translations]);

    const LOAD_GET_TRANSLATIONS = async (LANG_CODE) => {
        try {
            if (!SUPPORTED_LANGS.includes(LANG_CODE)) {
                throw new Error("Idioma no soportado");
            }

            const TRANSLATIONS = STATIC_TRANSLATIONS[LANG_CODE];

            if (!TRANSLATIONS) throw new Error("Traducciones no encontradas");

            onSetAlertTexts(TRANSLATIONS?.TEMPLATES?.alerts);

            setNameDataLanguageState({
                isLoading: false, currentLang: LANG_CODE, translations: TRANSLATIONS,
                availableLangs: SUPPORTED_LANGS, availableLangsMeta: Object.values(LANG_META),
            });

            if (typeof document !== "undefined") {
                document.documentElement.lang = LANG_CODE;
            }

            return TRANSLATIONS;

        } catch (error) {
            setNameDataLanguageState(prev => ({ ...prev, isLoading: false }));
            return null;
        }
    };

    useEffect(() => {
        let isMounted = true;

        const initLanguage = async () => {
            try {
                STORAGE_SESSION_HELPER.SET_STORAGE(APP_STORAGE.APP_LANGUAGE, "es");
                const LANG_TO_LOAD = "es";

                if (!isMounted) return;
                await LOAD_GET_TRANSLATIONS(LANG_TO_LOAD);
            } catch (err) {
                if (isMounted) {
                    setNameDataLanguageState(prev => ({ ...prev, isLoading: false }));
                }
            }
        };

        initLanguage();
        return () => { isMounted = false; };
    }, []);

    const cb__toggleTranslateCallback = useCallback(async (LANG_CODE) => {
        if (LANG_CODE !== "es") return;

        try {
            STORAGE_SESSION_HELPER.SET_STORAGE(APP_STORAGE.APP_LANGUAGE, LANG_CODE);
            await LOAD_GET_TRANSLATIONS(LANG_CODE);
        } catch (e) {
            // console.error("Error al cambiar idioma:", e);
        }
    }, []);

    const cb__refreshTranslateCallback = useCallback(async () => {
        return await LOAD_GET_TRANSLATIONS("es");
    }, []);

    return (
        <LanguageContext.Provider value={{
            useDataLanguage: useNameDataLanguageState, call_translate: cb__translateCallback, call_toggleTranslate: cb__toggleTranslateCallback, call_refreshTranslate: cb__refreshTranslateCallback
        }}>
            {children}
        </LanguageContext.Provider>
    );
};